import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <nav className="navbar is-dark">
      <div className="navbar-brand">
        <span className="navbar-item has-text-weight-bold is-size-5" style={{ cursor: 'default', color: 'inherit' }}>
          D&D Monster Tool
        </span>
      </div>
      <div className="navbar-menu">
        <div className="navbar-start">
          <Link className="navbar-item" to="/">Home</Link>
          <Link className="navbar-item" to="/monsters">Monsters</Link>
          <Link className="navbar-item" to="/encounter">Encounter</Link>
        </div>
      </div>
    </nav>
  );
}

export default Header;
